import { useEffect, useState } from "react";

import { AdminShell } from "@/components/admin/admin-shell";
import { ProductManager } from "@/components/admin/product-manager";
import { apiGet } from "@/services/api";
import type { Product } from "@/types";

/** `app/admin/products/page.tsx`. Always loads from the DB, never static data. */
export function AdminProductsPage() {
  const [products, setProducts] = useState<Product[]>([]);

  useEffect(() => {
    let active = true;
    void apiGet<{ products: Product[] }>("/api/admin/products").then((data) => {
      if (active) setProducts(data?.products ?? []);
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <AdminShell title="Products">
      <ProductManager initialProducts={products} />
    </AdminShell>
  );
}
